/**
 * Returns the datum from `data` whose `.date` is closest to `lookup`.
 * Both neighbours of the lookup position are considered, and the nearer one
 * wins ties go to the left neighbour.
 *
 * `datum.date` is expected to be a Moment.js object; `lookup` is a JS Date
 * (returned by a D3 time-scale's `.invert()`). Both are coerced to numeric
 * timestamps for comparison.
 */
export function findClosestDatum(data, lookup) {
  if (!data || data.length === 0) return undefined

  const rightIndex = data.findIndex(datum => datum.date >= lookup)

  if (rightIndex === -1) return data[data.length - 1]
  if (rightIndex === 0) return data[0]

  const right = data[rightIndex]
  const left = data[rightIndex - 1]

  return (lookup - left.date) <= (right.date - lookup) ? left : right
}
